import { useState } from 'react';
import { studentsService } from '../../services/studentsService';
import { BiExport } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';

const ExportStudentsButton = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const handleExport = async () => {
    try {
      setIsLoading(true);
      const blob = await studentsService.exportStudents();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'students.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    } catch (error) {
      console.error('Failed to export students:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleExport}
      disabled={isLoading}
      className="inline-flex items-center justify-center rounded-md bg-primary py-2 px-6 text-white hover:bg-opacity-90 disabled:bg-opacity-50 gap-2"
    >
      <BiExport size={16} />
      {isLoading ? (
        <svg className="h-5 w-5 animate-spin text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      ) : (
        <span>{t('Export Students')}</span>
      )}
    </button>
  );
};

export default ExportStudentsButton; 